import classNames from 'classnames';
import type { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';

import { hideScrollbar } from '@sorare/core/src/style/utils';

const Root = styled.div`
  --gap: var(--unit);
  --nb-items: 5.5;
  --max-item-width: var(--external-max-item-width, calc(12 * var(--unit)));

  display: flex;
  gap: var(--gap);
  padding: 0 var(--container-padding);
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  ${hideScrollbar}

  &.withMVP {
    padding-top: var(--double-unit);
    padding-left: 2px;
    padding-right: 2px;
  }

  & > * {
    flex: 1;
    min-width: min(
      var(--max-item-width),
      calc(
        ((100% + var(--gap)) - var(--gap) * (var(--nb-items) - 1)) /
          var(--nb-items)
      )
    );
    scroll-snap-align: center;
    scroll-snap-stop: always;
    max-width: var(--max-item-width);

    /** justify-content: center; hides the first items and are not visible on lower screen size, hence this hack to center the content */
    /** doing it with :before and :after on Root would be more elegant but it add unecessary spacing because of flex gaps */
    &:first-child {
      margin-left: auto;
    }
    &:last-child {
      margin-right: auto;
    }
  }

  & > [data-divider] {
    flex: 0 0 auto;
    min-width: auto;
  }
`;
type Props = {
  withMVP?: boolean;
  children: ReactNode[];
  style?: CSSProperties;
};

export const MobileSlots = ({ withMVP, children, style }: Props) => {
  return (
    <Root className={classNames({ withMVP })} style={style}>
      {children}
    </Root>
  );
};
